import axiosWrapper from "./wrapper";
import * as AppConstants from '../app/AppConstants';

export function olppPayCreate({netId, applicationId}) {
  const response = axiosWrapper(
    "post",
    `/api/olpp/payment/create`,
    {
      netId: netId,
      applicationId: applicationId,
      callbackurl: window.location.origin + "/olpp-callback" + window.location.pathname,
      failedcallbackurl: window.location.origin + window.location.pathname + "?status=" + AppConstants.OLPP_PAYMENT_MESSAGE.FAILED
    }
  );
  return response;
}